import {Fields} from './_models'

export const sortFieldsByOrder = (fields: Fields[]) =>
  [...fields].sort((left, right) => {
    const leftOrder = left.order ?? Number.MAX_SAFE_INTEGER
    const rightOrder = right.order ?? Number.MAX_SAFE_INTEGER
    if (leftOrder !== rightOrder) return leftOrder - rightOrder
    return Number(left.id ?? 0) - Number(right.id ?? 0)
  })

const sortSubmenusByOrder = (submenus: any[]) =>
  [...submenus].sort((left, right) => {
    const leftOrder = left.order ?? Number.MAX_SAFE_INTEGER
    const rightOrder = right.order ?? Number.MAX_SAFE_INTEGER
    if (leftOrder !== rightOrder) return leftOrder - rightOrder
    return Number(left.id ?? 0) - Number(right.id ?? 0)
  })

const sortMenusByOrder = (menus: any[]) =>
  [...menus].sort((left, right) => {
    const leftOrder = left.order ?? Number.MAX_SAFE_INTEGER
    const rightOrder = right.order ?? Number.MAX_SAFE_INTEGER
    if (leftOrder !== rightOrder) return leftOrder - rightOrder
    return Number(left.id ?? 0) - Number(right.id ?? 0)
  })

export const normalizeReportStructure = (reportData: any) => {
  if (!reportData?.menus) return reportData

  return {
    ...reportData,
    menus: sortMenusByOrder(reportData.menus).map((menu: any) => ({
      ...menu,
      submenus: sortSubmenusByOrder(menu.submenus || []).map((submenu: any) => ({
        ...submenu,
        fields: sortFieldsByOrder((submenu.fields || []) as Fields[]),
      })),
    })),
  }
}

/** Company customizations override master template (matches Library). */
export const resolveAssignmentTemplate = (assignment: any) =>
  normalizeReportStructure(assignment?.customTemplate ?? assignment?.template)
